import React from "react";
import { cn } from "../../../common/u1/cn";
import { StatusBadge } from "../../../common/u1/StatusBadge";
import { MemberPill } from "../../../common/u1/MemberPill";

/* Which company this page is about, and where it stands. */
export const MembershipStatusRow = ({ name, status = "claimed", member = false, hint, className = "" }) => (
  <div
    className={cn(
      "mt-4 flex flex-wrap items-center justify-between gap-3.5",
      "border-t border-[var(--line)] pb-[18px] pt-[22px]",
      className
    )}
  >
    <div className="flex flex-wrap items-center gap-3.5">
      <h3 className="m-0 text-[20px] font-bold text-[var(--ink)] font-sans">{name}</h3>
      <StatusBadge status={status} />
      {member && <MemberPill />}
    </div>
    {hint && (
      <span className="flex items-center gap-[7px] text-[13.5px] text-[var(--muted)] font-sans">
        {hint}
      </span>
    )}
  </div>
);

export default MembershipStatusRow;
